import { GeneralService } from './../../../services/general.service';
import { FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';


export class FormMake745Build {

    public buildForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): FormGroup {
        this.buildFormI(form, arrForm[0], generalService);
        this.buildFormII(form, arrForm[1], generalService);
        return form;
    }

    private buildFormI(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('centro_ensaque').setValue(formCard.get('centro_ensaque')?.value);
        form.get('data_ensaque').setValue(generalService.createDate(formCard.get('data_ensaque')?.value));
        form.get('numero_campo').setValue(formCard.get('numero_campo')?.value);
        form.get('safra').setValue(formCard.get('safra')?.value);
        form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc')?.value);
        form.get('geracao').setValue(formCard.get('geracao')?.value);
        form.get('lote_origem').setValue(formCard.get('lote_origem')?.value);
        form.get('peneira').setValue(formCard.get('peneira')?.value);
        form.get('lote_saida').setValue(formCard.get('lote_saida')?.value);
        form.get('status_lote').setValue(formCard.get('status_lote')?.value);
        form.get('peso_sessenta_mil_sementes_impressao_kg').setValue(formCard.get('peso_sessenta_mil_sementes_impressao_kg')?.value);
        form.get('peso_total_lote_kg').setValue(formCard.get('peso_total_lote_kg')?.value);
        form.get('estimativa_pa').setValue(formCard.get('estimativa_pa')?.value);
        form.get('linha_ensaque').setValue(formCard.get('linha_ensaque')?.value);
        form.get('turno_ensaque').setValue(formCard.get('turno_ensaque')?.value);
        form.get('responsavel_pelo_ensaque').setValue(formCard.get('responsavel_pelo_ensaque')?.value);

        return form;
    }

    private buildFormII(form: FormGroup, formCard: FormGroup, generalService: GeneralService): FormGroup {
        form.get('responsavel_pela_conferencia_lote').setValue(formCard.get('responsavel_pela_conferencia_lote')?.value);
        form.get('data_conferencia_fisica').setValue(generalService.createDate(formCard.get('data_conferencia_fisica')?.value));
        form.get('data_hora_apontamento').setValue(generalService.createDate(formCard.get('data_hora_apontamento')?.value));
        form.get('status_processo').setValue(formCard.get('status_processo')?.value);
        form.get('observacao').setValue(formCard.get('observacao')?.value);
        form.get('created_by').setValue(formCard.get('criado_por')?.value);

        return form;
    }

    public updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): void {
        this.updateFormI(form, arrForm[0], generalService);
        this.updateFormII(form, arrForm[1], generalService);
    }

    private updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('centro_ensaque').setValue(data.formulario.centro_ensaque);
        formCard.get('data_ensaque').setValue(generalService.convertStringToDate(data.formulario.data_ensaque));
        formCard.get('numero_campo').setValue(data.formulario.numero_campo);
        formCard.get('safra').setValue(data.formulario.safra);
        formCard.get('hibrido_rnc').setValue(data.formulario.hibrido_rnc);
        formCard.get('geracao').setValue(data.formulario.geracao);
        formCard.get('lote_origem').setValue(data.formulario.lote_origem);
        formCard.get('peneira').setValue(data.formulario.peneira);
        formCard.get('lote_saida').setValue(data.formulario.lote_saida);
        formCard.get('status_lote').setValue(data.formulario.status_lote);
        formCard.get('peso_sessenta_mil_sementes_impressao_kg').setValue(data.formulario.peso_sessenta_mil_sementes_impressao_kg);
        formCard.get('peso_total_lote_kg').setValue(data.formulario.peso_total_lote_kg);
        formCard.get('estimativa_pa').setValue(data.formulario.estimativa_pa);
        formCard.get('linha_ensaque').setValue(data.formulario.linha_ensaque);
        formCard.get('turno_ensaque').setValue(data.formulario.turno_ensaque);
        formCard.get('responsavel_pelo_ensaque').setValue(data.formulario.responsavel_pelo_ensaque);
    }

    private updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): void {
        formCard.get('responsavel_pela_conferencia_lote').setValue(data.formulario.responsavel_pela_conferencia_lote);
        formCard.get('data_conferencia_fisica').setValue(generalService.convertStringToDate(data.formulario.data_conferencia_fisica));
        formCard.get('data_hora_apontamento').setValue(generalService.convertStringToDate(data.formulario.data_hora_apontamento));
        formCard.get('status_processo').setValue(data.formulario.status_processo);
        formCard.get('observacao').setValue(data.formulario.observacao);
        formCard.get('criado_por')?.setValue(data.formulario.created_by);

    }

}
